module.exports = "/_next/static/chromiums/twitter-512x512-purpose-8fba7c8e8c178f65ddc42bf1abd62619.jpg";